import { questionType as questionTypes, pdl } from '@edulastic/constants'
import { ALL_PA_GRADES } from '@edulastic/constants/const/pear'

const { ALL_SUBJECT_NAMES } = pdl

// TK instead of PK for PreKindergarten is intentional
const filterData = [
  {
    mode: 'multiple',
    size: 'large',
    title: 'Grades',
    placeholder: 'All Grades',
    onChange: 'grades',
    data: ALL_PA_GRADES.map(({ description, code }) => ({
      value: code,
      text: description,
    })),
  },
  {
    size: 'large',
    title: 'Subject',
    onChange: 'subject',
    placeholder: 'All Subjects',
    mode: 'multiple',
    data: ALL_SUBJECT_NAMES.map((name) => ({
      value: name,
      text: name,
    })),
  },
  {
    size: 'large',
    title: 'Question Types',
    onChange: 'questionType',
    data: questionTypes.selectsData,
  },
  {
    size: 'large',
    title: 'Knowledge',
    onChange: 'depthOfKnowledge',
    data: [
      { value: '', text: 'All Depth of Knowledge' },
      { value: 'Recall', text: '1 - Recall' },
      { value: 'Skill/Concept', text: '2- Skill/Concept' },
      { value: 'Strategic Thinking', text: '3 - Strategic Thinking' },
      { value: 'Extended Thinking', text: '4 - Extended Thinking' },
    ],
  },

  {
    size: 'large',
    title: 'Difficulties',
    onChange: 'authorDifficulty',
    data: [
      { value: '', text: 'All Levels' },
      { value: 'Easy', text: 'Easy' },
      { value: 'Medium', text: 'Medium' },
      { value: 'Hard', text: 'Hard' },
    ],
  },
  {
    size: 'large',
    title: 'Status',
    onChange: 'status',
    data: [
      { value: '', text: 'All' },
      { value: 'published', text: 'Published' },
      { value: 'draft', text: 'Draft' },
    ],
    publisherOptions: [
      { value: 'inreview', text: 'In Review' },
      { value: 'rejected', text: 'Rejected' },
    ],
  },
]

export default filterData
